import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=a779bba2&scoped=true"
import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=a779bba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779bba2",
  null
  
)

export default component.exports